import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'prodsum_id': {
    title: '汇总单号',
    equation: city,
    type: 'input'
  },
  'type': {
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0006'
  },
  'status': {
    title: '单据状态',
    equation: city,
    type: 'select',
    dictionary: 'A0008'
  },
  'partner': {
    title: '订单客户',
    type: 'dialog',
    equation: cusname,
    dialog: {
      component: 'ClientSelect',
      title: '订单客户'
    }
  },
  'salescenter': {
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'name': {
    title: '客户名称',
    type: 'input',
    equation: all
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all
  },
  'matnr': {
    title: '产品',
    type: 'dialog',
    equation: cusname,
    dialog: {
      component: 'ProductSelect',
      title: '产品'
    }
  }

}

export const config1 = {
  'prodsum_id': {
    title: '汇总单号'
  },
  'uname': {
    title: '制单人'
  },
  'datum': {
    title: '提交日期'
  },
  'status': {
    title: '单据状态'
  },
  'remark': {
    title: '备注'
  }
}
export const config2 = {
  'prodsum_id': {
    title: '汇总单号'
  },
  'prodsum_item': {
    title: '汇总项目',
    width: 100
  },
  'product_id': {
    title: '产品编号',
    width: 200
  },
  'description': {
    title: '产品',
    width: 400
  },
  'degree': {
    title: '度数'
  },
  'planqty_box': {
    title: '计划数量(件)'
  },
  'planqty_bottle': {
    title: '计划数量(瓶)'
  },
  'kconfqty': {
    title: '看板确认数量(件)',
    width: 150
  },
  'lastconfm_qty': {
    title: '最终确认数量(件)',
    width: 150
  },
  'status': {
    title: '状态'
  },
  'remark': {
    title: '备注'
  }
}
export const config3 = {
  'prodpl_id': {
    title: '生产计划单号'
  },
  'prodpl_item': {
    title: '项目',
    width: 70
  },
  'prod_id': {
    title: '产品编号',
    width: 200
  },
  'description': {
    title: '产品',
    width: 400
  },
  'planqty_box': {
    title: '计划数量(件)'
  },
  'planqty_bottle': {
    title: '计划数量(瓶)'
  },
  'planqty_ton': {
    title: '计划数量(吨)'
  },
  'kconfqty': {
    title: '看板确认数量(件)',
    width: 150
  },
  'lastconfm_qty': {
    title: '最终确认数量(件)',
    width: 150
  },
  'prodsum_id': {
    title: '汇总计划编号'
  },
  'prodpltype': {
    title: '计划类型'
  },
  'name_soldto': {
    title: '客户',
    width: 200
  },
  'status': {
    title: '状态'
  },
  'datum': {
    title: '提交日期'
  }

}




// WEBPACK FOOTER //
// ./src/views/make-plan-manage/config/makeSumQuery.js